import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// رجیستر کردن کامپوننت‌های موردنیاز Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const LineChart = () => {
  // داده‌های نمودار
  const data = {
    labels: ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور"], // لیبل‌های فارسی
    datasets: [
      {
        label: "مصرف ترافیک (GB)", // عنوان داده‌ها
        data: [20, 40, 35, 50, 70, 90], // داده‌ها
        borderColor: "#00aaff", // رنگ خط
        backgroundColor: "rgba(0, 170, 255, 0.2)", // رنگ نقاط
        tension: 0.4, // منحنی بودن خطوط
        pointBackgroundColor: "#ffffff",
        pointBorderColor: "#00aaff",
        pointBorderWidth: 2,
        fill: true, // پر کردن زیر خط
      },
    ],
  };

  // تنظیمات نمودار
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "top",
        labels: {
          font: {
            family: "light", // تغییر فونت لیبل‌ها
            size: 14,
          },
        },
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (context) => `${context.raw} گیگابایت`, // اضافه کردن واحد فارسی
        },
      },
      title: {
        display: true,
        text: "نمودار مصرف کل ترافیک حساب های شما",
        font: {
          family: "light", // تغییر فونت عنوان
          size: 16,
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false, // حذف خطوط عمودی محور X
        },
        ticks: {
          font: {
            family: "light", // تغییر فونت محور X
            size: 12,
          },
        },
      },
      y: {
        grid: {
          color: "rgba(200, 200, 200, 0.2)", // خطوط شبکه محوری کم‌رنگ
        },
        ticks: {
          font: {
            family: "light", // تغییر فونت محور Y
            size: 12,
          },
          callback: (value) => `${value} گیگ`, // افزودن واحد فارسی
        },
        beginAtZero: true, // شروع محور Y از صفر
      },
    },
  };

  return (
    <div
      style={{
        maxWidth: "800px",
        margin: "0 auto",
        padding: "20px",
        direction: "rtl",
      }}
    >
      <Line data={data} options={options} />
    </div>
  );
};

export default LineChart;
